import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentService } from 'app/store/services/content.service';
import { IQuickResponse } from 'app/store/models/content.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { SessionService } from '../../store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserType } from '../../store/models/user.model';
@Component({
  selector: 'app-quick-response-list',
  templateUrl: './quick-response-list.component.html',
  styleUrls: ['./quick-response-list.component.scss'],
})
export class QuickResponseListComponent implements OnInit, OnDestroy {
  quickResponses: IQuickResponse[];
  popoverText =
    'Quick Responses are a great way to store common responses.  You can customize up to 20 Quick Responses and easily bring them into your contact replies.  This is a great place to store About Us information, marketing materials via links, responses to common objections, etc.  After you create your Quick Responses, you can click anywhere in any response dialog box and bring in the correct Quick Response by using the drop down.';

  editButtonProperties: Button = {
    size: ButtonSize.SMALL,
    color: ButtonColor.BLUE,
    text: 'Edit',
    onClick: (item: IQuickResponse) =>
      this.router.navigate(['contents', 'quick_responses', item.id, 'edit']),
  };

  newButtonProperties: Button = {
    text: 'Create',
    color: ButtonColor.ORANGE,
    size: ButtonSize.SMALL,
    onClick: () => this.router.navigate(['contents', 'quick_responses', 'new']),
  };

  iconQuestionCircle = faQuestionCircle;

  private readonly destroy$ = new Subject<boolean>();

  constructor(
    private contentService: ContentService,
    private router: Router,
    private leftMenuService: LeftMenuService,
    private readonly sessionService: SessionService
  ) {}

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(userSession => {
        if (
          userSession &&
          [UserType.PARTNER, UserType.MANAGER].indexOf(
            userSession.user_type
          ) !== -1
        ) {
          // remove manager and partner from the page
          this.router.navigate(['/']);
          return;
        }

        if(userSession && userSession.user_type === UserType.MASTER && userSession.id !== 1) {
          // remove master users except the main one from the page
          this.router.navigate(['/']);
          return;
        }

        this.leftMenuService.expand('content');
        this.contentService
          .getQuickResponses()
          .subscribe(res => (this.quickResponses = res.items));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
